import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  RelativeDateTime
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function EventsTable({ ilk, pagination, sorting, filters }) {
  const [data, error] = useApi({
    url: `/groups/obex/ilks/${ilk}/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      operation: filters.filtersApplied.eventType
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Event',
        getCell: (row) => row.operation,
        columnSize: ['minmax(100px, auto)']
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Debt
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.dart}
            options={{
              nullable: null,
              trend: true,
              iconSize: '0'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'dart'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Collateral
            <CryptoIcon
              name={data.collateral_symbol}
              address={data.collateral_address}
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.dink}
            options={{
              trend: true,
              nullable: null,
              iconSize: '0',
              currency: 'USD'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'dink'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '3xs']} color="muted" alignItems="center">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
